<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 text-left bg-Info disabled color-palette">
      <div class="card">
        <div class="card-header">
          <img class="img-circle" src="../assets/images/bsflogo.png" alt="User Image"
            style="width: 50px; height: 50px; background-color: white;">
          &nbsp; &nbsp; <span style="font-size:20px;font-weight: bolder; color: #000;"><a> <i class="fa fa-truck"></i>
              คิวและลานอ้อย
            </a> </span>&nbsp; &nbsp;
          <span style="color: #000;"> ({{todaydate}}) </span>
          <!--
                  <div class="row">                           
                      <img src="../assets/images/bsflogo.png" class="img-circle" alt="User Image" style="width: 10%; height: 100%; background-color: white;">
                  <div class="col-4 text-left" style="color: black;">
                      <i class="fas fa-truck"></i> คิวและลานอ้อย วันที่ {{todaydate}}
                  </div>
              </div> -->
        </div>
      </div>
    </div>
  </div>

  <!-- สรุปรถแจ้งคิว -->
  <div class="card card-outline card-primary">
    <div class="card-header">
      <h3 class="card-title">สรุปรถแจ้งคิว</h3>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" data-card-widget="collapse">
          <i class="fas fa-minus"></i>
        </button>
      </div>
      <!-- /.card-tools -->
    </div>
    <!-- /.card-header -->
    <div class="card-body">
      <div class="row justify-content-md-center">
        <!-- คิวล็อค -->
        <div class="col-md-2" *ngFor="let item of  q1">
          <div class="info-box bg-aqua bg-primary">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวล็อค</span>
              <span class="info-box-number">{{item.cntqtype2}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype2.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวรถตัด -->
        <div class="col-md-2" *ngFor="let item of  q3">
          <div class="info-box bg-aqua bg-primary">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวรถตัด</span>
              <span class="info-box-number">{{item.cntqtype2}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype2.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวอ้อยลาน -->
        <div class="col-md-2" *ngFor="let item of  q4">
          <div class="info-box bg-aqua bg-primary">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวอ้อยลาน</span>
              <span class="info-box-number">{{item.cntqtype2}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype2.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
          </div>
        </div>
        <!-- คิวนาโพธิ์ -->
        <div class="col-md-2" *ngFor="let item of  q6">
          <div class="info-box bg-aqua bg-primary">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวนาโพธิ์</span>
              <span class="info-box-number">{{item.cntqtype2}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype2.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวรถโยน -->
        <div class="col-md-2" *ngFor="let item of  q2">
          <div class="info-box bg-aqua bg-primary">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวรถโยน</span>
              <span class="info-box-number">{{item.cntqtype2}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype2.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>

        <div class="col-md-2" *ngFor="let item of sumq">
          <div class="text-right">
            <h3> จำนวนรถ <label style="color: blue;">{{item.printQ2|number}}</label> คัน,<br> ประมาณอ้อย <label
                style="color: red;">{{item.qaskum|number}}</label> ตัน </h3>
          </div>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
  </div>

  <!-- สรุปรถเรียกคิว -->

  <div class="card card-outline card-success">
    <div class="card-header">
      <h3 class="card-title">สรุปรถเรียกคิว</h3>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" data-card-widget="collapse">
          <i class="fas fa-minus"></i>
        </button>
      </div>
      <!-- /.card-tools -->
    </div>
    <!-- /.card-header -->
    <div class="card-body">
      <div class="row justify-content-md-center">
        <!-- คิวล็อค -->
        <div class="col-md-2" *ngFor="let item of  q1">
          <div class="info-box bg-aqua bg-success">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวล็อค</span>
              <span class="info-box-number">{{item.cntqtype3}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype3.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>

        <!-- คิวรถตัด -->
        <div class="col-md-2" *ngFor="let item of  q3">
          <div class="info-box bg-aqua bg-success">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวรถตัด</span>
              <span class="info-box-number">{{item.cntqtype3}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype3.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div> <!-- คิวอ้อยลาน -->
        <div class="col-md-2" *ngFor="let item of q4">
          <div class="info-box bg-aqua bg-success">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวอ้อยลาน</span>
              <span class="info-box-number">{{item.cntqtype3}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype3.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
          </div>
        </div>
        <!-- คิวนาโพธิ์ -->
        <div class="col-md-2" *ngFor="let item of q6">
          <div class="info-box bg-aqua bg-success">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวนาโพธิ์</span>
              <span class="info-box-number">{{item.cntqtype3}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype3.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวรถโยน -->
        <div class="col-md-2" *ngFor="let item of  q2">
          <div class="info-box bg-aqua bg-success">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวรถโยน</span>
              <span class="info-box-number">{{item.cntqtype3}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype3.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>

        <div class="col-md-2" *ngFor="let item of sumq">
          <div class="text-right">
            <h3>จำนวนรถ <label style="color: blue;">{{item.printQ3|number}}</label> คัน ,<br> ประมาณอ้อย <label
                style="color: red;">{{item.qcallsum|number}}</label> ตัน </h3>
          </div>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
  </div>

  <!-- สรุปรถจองคิว -->

  <div class="card card-outline card-orange">
    <div class="card-header">
      <h3 class="card-title">สรุปรถจองคิว</h3>

      <div class="card-tools">
        <button type="button" class="btn btn-tool" data-card-widget="collapse">
          <i class="fas fa-minus"></i>
        </button>
      </div>
      <!-- /.card-tools -->
    </div>
    <!-- /.card-header -->
    <div class="card-body">
      <div class="row justify-content-md-center">
        <!-- คิวล็อค -->
        <div class="col-md-2">
          <div class="info-box bg-aqua bg-orange" *ngFor="let item of  q1">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวล็อค</span>
              <span class="info-box-number">{{item.cntqtype1}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype1.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>

        <!-- คิวรถตัด -->
        <div class="col-md-2">
          <div class="info-box bg-aqua bg-orange" *ngFor="let item of  q3">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวรถตัด</span>
              <span class="info-box-number">{{item.cntqtype1}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype1.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวอ้อยลาน -->
        <div class="col-md-2" *ngFor="let item of q4">
          <div class="info-box bg-aqua bg-orange">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวอ้อยลาน</span>
              <span class="info-box-number">{{item.cntqtype1}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype1.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
          </div>
        </div>
        <!-- คิวนาโพธิ์ -->
        <div class="col-md-2" *ngFor="let item of q6">
          <div class="info-box bg-aqua bg-orange">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวนาโพธิ์</span>
              <span class="info-box-number">{{item.cntqtype1}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype1.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวรถโยน -->
        <div class="col-md-2">
          <div class="info-box bg-aqua bg-orange" *ngFor="let item of  q2">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวรถโยน</span>
              <span class="info-box-number">{{item.cntqtype1}} คัน</span>
              <div class="progress">
                <div class="progress-bar" style="width: 70%"></div>
              </div>
              <span class="progress-description">
                ประมาณ {{item.wgtQtype1.toLocaleString('ar-TH')}} ตัน
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <div class="col-md-2" *ngFor="let item of sumq">
          <div class="text-right">
            <h3> จำนวนรถ <label style="color: blue;">{{item.printQ1|number}}</label> คัน,<br> ประมาณอ้อย
              <label style="color: red;">{{item.qbooksum|number}}</label> ตัน
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- รถ แจ้งคิว+เรียกคิว ขณะนี้ -->

  <div class="card card-outline card-success">
    <div class="card-header">
      <h3 class="card-title">รถ แจ้งคิว+เรียกคิว ขณะนี้</h3>
      <div class="card-tools">
        <span class="badge badge-primary">{{countcar}}</span>
        <button class="btn btn-sm btn-tool" (click)="ExportExcelData1();">
          <i class="far fa-file-excel"></i>
        </button>
        <button type="button" class="btn btn-tool" data-card-widget="collapse">
          <i class="fas fa-minus"></i>
        </button>
      </div>
      <!-- /.card-tools -->
    </div>
    <!-- /.card-header -->
    <div class="card-body" style="overflow: auto;">
      <table class="table table-sm text-nowrap table-head-fixed" #truckwaitcall>
        <thead>
          <tr>
            <td>โซน</td>
            <td>นสส.</td>
            <td>ชื่อ-สกุล</td>
            <td>ทะเบียน</td>
            <td>รอบ</td>

            <td>คิวที่</td>
            <td>คิว</td>
            <td>เลขแปลง</td>
            <td>เวลาแจ้งคิว</td>
            <td><i class="fas fa-truck"></i></td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of carinfront" [ngClass]="{'bg-secondary': c.ref_doc1 == 'Z'}">
            <td>{{c.supzone}}</td>
            <td>{{c.supcode}}</td>
            <td>{{c.fmname}}</td>
            <td>{{c.regtruck}}</td>
            <td>{{c.ref_doc1}}</td>
            <td>{{c.q_id}}</td>
            <td>{{c.qdesc}}</td>
            <td>{{c.landno}}</td>
            <td>
              <span *ngIf="c.ref_doc1 != 'Z'">{{(c.date_in_th)}}</span>
            </td>
            <td>{{c.q_desc}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- รถชั่งเข้าขณะนี้ -->
  <div class="card card-outline card-danger">
    <div class="card-header">
      <h3 class="card-title">รถชั่งเข้าขณะนี้</h3>
      <div class="card-tools">
        <span class="badge badge-primary">{{countinweight}}</span>
        <button type="button" class="btn btn-tool" data-card-widget="collapse">
          <i class="fas fa-minus"></i>
        </button>
      </div>
      <!-- /.card-tools -->
    </div>
    <!-- /.card-header -->
    <div class="card-body" style="overflow: auto;">
      <table class="table table-sm text-nowrap table-head-fixed" #waitforweight>
        <thead>
          <tr>
            <td>ลำดับ</td>
            <td>ชื่อ - สกุล</td>
            <td>ทะเบียน</td>
            <td>รอบ</td>
            <td>คิวที่</td>
            <td>โซน</td>
            <td>เวลาแจ้งคิว</td>
            <td>เวลาชั่งเข้า</td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of carinweight">
            <td>{{item.prod_line.trim()}} {{item.date_in_no}}</td>
            <td>{{item.fmname}}</td>
            <td>{{item.regtruck}}</td>
            <td>{{item.ref_doc1}}</td>
            <td>{{item.q_id}}</td>
            <td>{{item.supzone.trim()}}</td>
            <td>{{FormatThai(item.date_in)}}</td>
            <td>{{FormatThai(item.wgt_in_dt)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>